import { render, staticRenderFns } from "./form-confirm.vue?vue&type=template&id=2703b31a&scoped=true&"
import script from "./form-confirm.vue?vue&type=script&lang=js&"
export * from "./form-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2703b31a",
  null
  
)

export default component.exports